import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import MessageAlert from 'app/components/MessageAlert'
import moment from 'moment'
import { makeStyles } from '@material-ui/core/styles'
import PlayArrowIcon from '@material-ui/icons/PlayArrow'
import PauseIcon from '@material-ui/icons/Pause'
import { useIntl, FormattedMessage } from 'react-intl'

const useStyles = makeStyles((theme) => ({
  audioPlayerWrapper: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 25,
    marginBottom: 15,
  },
  audioPlayer: {
    display: 'flex',
    width: '100%',
    height: 48,
    backgroundColor: '#f2f2f2',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderRadius: 25,
  },
  control: {
    color: '#fff',
    width: 36,
    height: 36,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '50%',
    cursor: 'pointer',
    marginLeft: 6,
    overflow: 'hidden',
    '& div': {
      backgroundColor: '#0073b1',
      width: '100%',
      height: '100%',
      fontSize: 14,
      justifyContent: 'center',
      display: 'flex',
      alignItems: 'center',
    },
  },
  currentTime: {
    fontSize: 14,
    color: '#a8a8a8',
    marginLeft: 16,
  },
  progressBar: {
    position: 'relative',
    flexGrow: 1,
    margin: '0 8px',
    height: 4,
    borderRadius: 5,
    backgroundColor: '#e5e5e5',
  },
  progressBarBounce: {
    width: 14,
    height: 14,
    backgroundColor: '#0073b1',
    borderRadius: '50%',
    position: 'absolute',
    bottom: -5,
    cursor: 'pointer',
    left: 0,
    zIndex: 99,
  },
  progressBarLine: {
    height: 4,
    width: 0,
    backgroundColor: '#0073b1',
    position: 'absolute',
    left: 0,
  },
  duration: {
    fontSize: 14,
    color: '#a8a8a8',
    marginRight: 16,
  },
  playerInfo: {
    marginTop: 8,
    color: '#404040',
  },
}))

const timerFormat = 'm:ss'

const initAudioState = {
  currentMusic: null,
  totalDuration: 0,
  currentTime: '0:00',
  duration: '0:00',
  position: 0,
  playerRef: null,
}

let isChangePosition = false
function setIsChangePosition(bool) {
  isChangePosition = bool
}
const AUDIO_PROCESS = 'process'

export default (props) => {
  let { currentMusicPlaying, isOnline, notification } = props
  const classes = useStyles()
  const { formatMessage } = useIntl()
  const [audioState, setAudioState] = useState(initAudioState)
  const [isAudioLoad, setIsAudioLoad] = useState(false)
  const [isPlayState, setIsPlayState] = useState(false)
  const dispatch = useDispatch()

  const onLoadedData = (currentMusic) => {
    let duration =
      '-' + moment.utc(currentMusic.duration * 1000).format(timerFormat)
    setIsAudioLoad(true)
    setAudioState({
      ...initAudioState,
      currentMusic,
      totalDuration: currentMusic.duration,
      currentTime: '0:00',
      duration,
    })

    currentMusic.onended = function () {
      setIsPlayState(false)
    }
  }

  const listEventListener = (currentMusic) => {
    currentMusic.onerror = function () {
      dispatch(
        MessageAlert.showError({
          message: formatMessage({ id: 'audioPlayer.errorMsg.error' }),
        }),
      )
    }
    window.addEventListener('offline', eventListenerOffline)
  }

  const eventListenerOffline = () => {
    if (isOnline.isOnline) {
      isOnline.isOnline = false
      dispatch(
        MessageAlert.showError({
          message: formatMessage({ id: 'audioPlayer.errorMsg.failed' }),
        }),
      )
    }
  }

  const handlePlay = () => {
    setIsChangePosition(false)
    emptyPlayerList()
    let currentMusic = audioState.currentMusic
    currentMusicPlaying.push({
      audio: currentMusic,
      setIsPlayState,
    })

    if (currentMusic) {
      currentMusic.addEventListener('timeupdate', () =>
        moveProgressByDuration(currentMusic),
      )
      currentMusic.play()
    }
    setIsPlayState(true)
  }

  const handlePause = () => {
    let currentMusic = audioState.currentMusic
    setIsPlayState(false)
    currentMusic && currentMusic.pause()
  }

  const handleOnMouseMove = (e) => {
    if (isChangePosition) {
      moveProgressByPosition(e)
    }
  }

  const handleOnMouseUp = () => {
    setIsChangePosition(false)
  }

  const handleProgressOnMouseDown = () => {
    setIsChangePosition(true)
  }

  const moveProgressByPosition = (e) => {
    let elemData = audioState.playerRef.getBoundingClientRect()
    let newPosition = e.clientX - elemData.left
    if (newPosition >= 0 && newPosition <= elemData.width) {
      let position = (100 * newPosition) / elemData.width
      if (position >= 99) {
        position = 99
      }

      let newTime = (audioState.totalDuration * position) / 100
      let currentTime = moment.utc(newTime * 1000).format(timerFormat)
      let duration =
        '-' +
        moment
          .utc((audioState.totalDuration - newTime) * 1000)
          .format(timerFormat)
      audioState.currentMusic && (audioState.currentMusic.currentTime = newTime)

      setAudioState({
        ...audioState,
        currentTime: currentTime,
        duration: duration,
        position: position,
      })
    }
  }

  const moveProgressByDuration = (currentMusic) => {
    if (!isChangePosition) {
      let currentTime = moment
        .utc(currentMusic.currentTime * 1000)
        .format(timerFormat)
      let duration =
        '-' +
        moment
          .utc((audioState.totalDuration - currentMusic.currentTime) * 1000)
          .format(timerFormat)

      let position = (currentMusic.currentTime / audioState.totalDuration) * 100
      if (position >= 99) {
        position = 99
      }

      setAudioState({
        ...audioState,
        currentTime,
        duration,
        position,
      })
    }
  }

  const emptyPlayerList = () => {
    if (currentMusicPlaying.length > 0) {
      currentMusicPlaying.forEach((item, key) => {
        item.audio && item.audio.pause()
        item.setIsPlayState && item.setIsPlayState(false)
        currentMusicPlaying.splice(key, 1)
      })
    }
  }

  const setRef = (ref) => {
    if (ref && !audioState.playerRef) {
      setAudioState({
        ...audioState,
        playerRef: ref,
      })
    }
  }

  useEffect(() => {
    isOnline.isOnline = true
    emptyPlayerList()
    setAudioState(initAudioState)
    if (notification.audioUrl !== AUDIO_PROCESS) {
      let currentMusic = new Audio(notification.audioUrl)
      if (currentMusic) {
        currentMusic.addEventListener('loadeddata', () => {
          onLoadedData(currentMusic)
        })
        listEventListener(currentMusic)
      }
    }

    return () => {
      window.removeEventListener('offline', eventListenerOffline)
      emptyPlayerList()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [notification.audioUrl])

  return (
    <div className={classes.audioPlayerWrapper}>
      {isAudioLoad && (
        <div
          className={classes.audioPlayer}
          onMouseUp={handleOnMouseUp}
          onMouseMove={handleOnMouseMove}
          onMouseLeave={handleOnMouseUp}
        >
          <div className={classes.control}>
            {isPlayState ? (
              <div onClick={handlePause}>
                <PauseIcon />
              </div>
            ) : (
              <div onClick={handlePlay}>
                <PlayArrowIcon />
              </div>
            )}
          </div>

          <div className={classes.currentTime}>{audioState.currentTime}</div>

          <div
            ref={setRef}
            className={classes.progressBar}
            onClick={moveProgressByPosition}
          >
            <div
              className={classes.progressBarBounce}
              style={{ left: audioState.position + '%' }}
              onMouseDown={handleProgressOnMouseDown}
            />
            <div
              className={classes.progressBarLine}
              style={{ width: audioState.position + '%' }}
            />
          </div>

          <div className={classes.duration}>{audioState.duration}</div>
        </div>
      )}
      <div className={classes.playerInfo}>
        <FormattedMessage
          id="audioPlayer.title"
          values={{
            position: isPlayState ? 'Listening' : 'Listen',
            title: '',
            languageName: notification.language.name,
          }}
        />
      </div>
    </div>
  )
}
